import React from 'react'
import { withRouter } from "react-router-dom";
import { TableOp } from '../../../components/table/TableOps.tsx';
import TableComponent from '../../../components/table/TableOps';
import Zona from './Zona.js';
import { Button } from '@material-ui/core';
import Http from '../../../Http';

class Zonas extends TableComponent {

  componentDidMount() {
    this.tableConfig(
      { dataUrl: 'zona/filter', deleteUrl: 'zona/delete', deleteField: 'zona_descripcion', modUrl: '/Catalogo/Zona' },
      TableOp.Table('Zonas', [
        { label: 'Clave', id: 'zona' },
        { label: 'Zona', id: 'zona_descripcion' },
        { label: 'Tipo', id: 'zona_tipo' },
        { label: 'Ciudades', id: 'ciudades' },
      ],[ 
        { id: 'edit', icon: 'edit' },
        { id: 'delete', icon: 'delete' } ]))
    this.table();
  }

  downloadReport = async () => {
    const Resp = await Http.get(`zona/excel`, true, 'arraybuffer')
    if (!Resp.error) {
      const blob = new Blob([Resp], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' });
      const a = document.createElement('a');
      const url = URL.createObjectURL(blob)
      a.style.display = 'none';
      a.href = url;
      a.download = `reporte.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
    } else {
      this.setState({ sbOpen: true, sbMsg: 'Ocurrio un error al generar el archivo' });
    }
  }

  render() {

    return (
      <div>
      <Button onClick={this.downloadReport} >
        Descargar Excel
      </Button>
        <div>
          {
             
            <Zona  onSave={() => { this.table() }}></Zona>
          }
          {
             
            <this.TableRender  />
          }
        </div>
      </div>
    )
  }
}

export default withRouter(Zonas)